export function getScalarJointReferenceValue(joint) {
  const referenceValue = Number(joint?.initialRef);
  return Number.isFinite(referenceValue) ? referenceValue : 0;
}

export function getScalarJointRelativeValue(joint, rawValue) {
  const value = Number(rawValue);
  if (!Number.isFinite(value)) return 0;
  return value - getScalarJointReferenceValue(joint);
}
